/** 营业期限起判定天数（含今天共 180 天） */
const BUSINESS_START_DAYS = 180;

/**
 * 根据营业期限起判断是否已满 180 天（含今天）
 * 规则：今天往前数 180 天含今天，营业期限起 ≤ 该日则为已满
 * @param companyBusinessStartAt 营业期限起
 * @returns 1 是 0 否；无日期返回 null
 */
export const calcIsOverSixMonths = (
  companyBusinessStartAt: string
): 0 | 1 | null => {
  if (!companyBusinessStartAt) return null;
  const start = new Date(companyBusinessStartAt.replace(/-/g, '/'));
  if (Number.isNaN(start.getTime())) return null;
  start.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const cutoff = new Date(today);
  cutoff.setDate(cutoff.getDate() - (BUSINESS_START_DAYS - 1));
  return start.getTime() <= cutoff.getTime() ? 1 : 0;
};
